// import React from 'react';
import ReactDOM from 'react-dom/client';
import './i18n/i18n';
import './utils/setupAxiosInterceptors';
import './index.css';
import './styles/design-system.css';
import App from './App';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import reportWebVitals from './reportWebVitals';
import { Provider } from "react-redux";
import store from './redux/store';
import { ThemeProvider } from "./context/ThemeContext";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </Provider>,
);

// Defer non-critical Font Awesome CSS + Bootstrap JS until after first paint
const deferNonCriticalAssets = () => {
  import('font-awesome/css/font-awesome.min.css');
  import('bootstrap/dist/js/bootstrap.bundle.min.js');
};

if (typeof window !== 'undefined') {
  // Prefer immediate post-paint load so Bootstrap modals (e.g. forgot password) work quickly
  if (typeof window.requestAnimationFrame === 'function') {
    window.requestAnimationFrame(() => {
      window.setTimeout(deferNonCriticalAssets, 0);
    });
  } else {
    window.setTimeout(deferNonCriticalAssets, 0);
  }
}

// إلغاء تسجيل أي Service Worker قديم عند المستخدمين اللي عندهم نسخة قديمة
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((registration) => {
      registration.unregister();
    });
  });

  if (window.caches) {
    caches.keys().then((names) => {
      names.forEach((name) => {
        caches.delete(name);
      });
    });
  }
}

reportWebVitals();
